<template>
  <router-view :key="currentLocaleLanguage" />
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

import { Mutations } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/keenthemes";
import { getCurrentLocale, setLocale } from "@/core/helpers/translation";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();

    const i18n = useI18n();

    const currentLocaleLanguage = computed(() => {
      return i18n.locale.value;
    });

    onMounted(() => {
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

      nextTick(() => {
        const lang = getCurrentLocale() as string;
        initializeComponents();
        setLocale(lang);
        i18n.locale.value = lang;
      });
    });

    return { currentLocaleLanguage };
  },
});
</script>

<style lang="scss">
@import "~bootstrap-icons/font/bootstrap-icons.css";
@import "~apexcharts/dist/apexcharts.css";
@import "~quill/dist/quill.snow.css";
@import "~animate.css";
@import "~sweetalert2/dist/sweetalert2.css";
@import "~nouislider/distribute/nouislider.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~socicon/css/socicon.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "~dropzone/dist/dropzone.css";
@import "~@vueform/multiselect/themes/default.css";
@import "~prism-themes/themes/prism-shades-of-purple.css";
@import "~element-plus/dist/index.css";

// Main demo style scss
@import "assets/sass/plugins";
// @import "assets/css/style.css";
// @import "assets/css/style.rtl.css";
//RTL version styles
//@import "assets/css/style.rtl.css";

// set background color of success toast messages.
.success-notification {
  background: #e8fff3 !important;
}

// set success toast messages color of title.
.success-notification .el-notification__title {
  color: #50cd89;
}

// set success toast messages color of content.
.success-notification .el-notification__content {
  color: #50cd89;
}

// set background color of error toast messages.
.error-notification {
  background: #fff5f8 !important;
  // color: #f1416c;
}

// set error toast messages color of title.
.error-notification .el-notification__title {
  color: #f1416c;
}

// set error toast message content of content.
.error-notification .el-notification__content {
  color: #f1416c;
}

// align close button in rtl locale.
.right-notification .el-notification__group .el-notification__closeBtn {
  right: 15px !important;
  left: unset !important;
}

// align close button in ltr locale.
.left-notification .el-notification__group .el-notification__closeBtn {
  left: 15px !important;
  right: unset !important;
}

// align content to left.
.right-notification .el-notification__content {
  text-align: left;
}

// align content to right.
.left-notification .el-notification__content {
  text-align: right;
}

// text overflow ellipsis
.text-overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-rate .el-rate__icon {
  font-size: 1.5vw;
}

// rate in ltr langs.
.el-rate-ltr .el-rate__icon {
  margin-right: 6px;
  margin-left: 0;
}

// rate in rtl langs.
.el-rate-rtl .el-rate__icon {
  margin-left: 6px;
  margin-right: 0;
}

.el-select__wrapper {
  height: 100%;
}

.el-select-ltr .el-select__wrapper {
  text-align: left !important;
}

.el-select-rtl .el-select__wrapper {
  text-align: right !important;
}

// customize tabs style for ltr & rtl locales.
.el-tabs-ltr .el-tabs__nav {
  float: left;
}

.el-tabs-rtl .el-tabs__nav {
  float: right;
}

.el-tabs-ltr .el-tabs__item {
  padding-right: 20px;
}

.el-tabs-rtl .el-tabs__item {
  padding-left: 20px;
}

.el-tabs-ltr .el-tabs__item:nth-child(2) {
  padding-left: 0 !important;
  padding-right: 20px !important;
}

.el-tabs-rtl .el-tabs__item:nth-child(2) {
  padding-right: 0 !important;
  padding-left: 20px !important;
}

.el-tabs-ltr .el-tabs__item:last-child {
  padding-right: 0 !important;
  padding-left: 20px !important;
}

.el-tabs-rtl .el-tabs__item:last-child {
  padding-left: 0 !important;
  padding-right: 20px !important;
}

// customize error message font size for 3x larege screens.
@media screen and (min-width: 2000px) {
  html,
  body {
    font-size: 18px !important;
  }
}

// customize rate component.
@media screen and (max-width: 767px) {
  .el-rate .el-rate__icon {
    font-size: 15px;
  }
}

@media screen and (max-width: 500px) {
  .el-rate .el-rate__icon {
    font-size: 12px;
  }
}
</style>
